module.exports = __webpack_public_path__ + "img/step4-desktop.6247a9b8.jpg";